var map = {
	"./chips.png": "5fb3",
	"./chips1.png": "f80f",
	"./chips10.png": "0ca0",
	"./chips100.png": "e563",
	"./chips1000.png": "3593",
	"./chips10000.png": "bdda",
	"./chips100000.png": "78e4",
	"./chips2.png": "443d",
	"./chips20.png": "8962",
	"./chips200.png": "2cb0",
	"./chips2000.png": "4253",
	"./chips20000.png": "5685",
	"./chips200000.png": "ca49",
	"./chips5.png": "d0e6",
	"./chips50.png": "5054",
	"./chips500.png": "6b9a",
	"./chips5000.png": "419d",
	"./chips50000.png": "ba5a",
	"./chips_seting_btn.png": "d04e",
	"./chipsc.png": "dfe1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f477";